// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"1d70764b","287":"f9baaa4a","289":"00f29cba","732":"7590549b"}[chunkId] + ".chunk.js";
};